import { render, staticRenderFns } from "./OpenserveWizard.vue?vue&type=template&id=22a989f3&"
import script from "./OpenserveWizard.vue?vue&type=script&lang=js&"
export * from "./OpenserveWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports